import React from "react";
import CustomModal from "./CustomModal";
import CustomMultiSelect from "./CustomMultiSelect";
import { useDispatch, useSelector } from "react-redux";
import { xhrApiGetToken } from "../../utilities/xhr-api";
import {
	xhrClinicalShareExam,
} from "../../utilities/xhr-clinical";
import translator from "../../utilities/translator";
import formattedDate from "../../utilities/dateFormatter";
import { toastUtil, toastUtilText } from "../../utilities/toast-util";

function ExamShareModal({
	showExamShareModal,
	setShowExamShareModal,
	currentSelectedExam,
}) {
	const currentLanguage = useSelector(
		(state) => state.session.userPreferences.language
	);
	const token = useSelector((state) => state.session.token);

	const userInfo = useSelector((state) => state.session.userInfo);
	const userPermissions = useSelector((state) => state.session.userPermissions);

	const [expireDays, setExpireDays] = React.useState(30);
	const [shareImages, setShareImages] = React.useState(true);
	const [shareReport, setShareReport] = React.useState(true);
	const [shareEmail, setShareEmail] = React.useState("");
	const [resultAskedToken, setResultAskedToken] = React.useState("");

	const [activeTab, setActiveTab] = React.useState("link");
	const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

	React.useEffect(() => {
		if (showExamShareModal) {
			setResultAskedToken("");
			setShareEmail("");
			setActiveTab("link");
		}
	}, [showExamShareModal]);
	React.useEffect(() => {
		if (activeTab === "email" || activeTab === "link") {
			setResultAskedToken("");
		}
	}, [activeTab]);
	return (
		<CustomModal
			isVisible={showExamShareModal}
			title={translator(currentLanguage, "shareexam")}
			width="auto"
			maxWidth="460px"
			onCancel={() => {
				setShowExamShareModal(false);
				setResultAskedToken("");
			}}
			style={{
				maxHeight: "75vh", // 🔹 controla a altura total visível
				overflowY: "auto", // 🔹 adiciona scroll suave dentro da modal
			}}
		>
			<div
				style={{
					display: "flex",
					borderBottom: "2px solid #f0f0f0",
					marginBottom: "16px",
				}}
			>
				{[
					{ id: "link", label: translator(currentLanguage, "sharebylink") },
					{ id: "email", label: translator(currentLanguage, "sharebyemail") },
				].map((tab) => (
					<div
						key={tab.id}
						onClick={() => setActiveTab(tab.id)}
						style={{
							flex: 1,
							textAlign: "center",
							padding: "10px 0",
							cursor: "pointer",
							fontWeight: activeTab === tab.id ? 700 : 500,
							color: activeTab === tab.id ? "#e78e4b" : "#05585E",
							borderBottom:
								activeTab === tab.id
									? "3px solid #05585E"
									: "3px solid transparent",
							transition: "all 0.2s ease",
							opacity: activeTab === tab.id ? "1" : "0.3",
						}}
					>
						{tab.label}
					</div>
				))}
			</div>

			<div
				style={{
					display: "flex",
					flexDirection: "column",
					gap: "16px",
					padding: "20px",
					background: "#fff",
					borderRadius: "12px",
					boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
					width: "100%",
					minWidth: "300px",
					maxWidth: "100%",
					height: "auto", // 👈 importante
					overflow: "visible", // 👈 garante expansão natural
				}}
			>
				<div
					style={{
						background: "#fff8ef",
						borderLeft: "4px solid #e78e4b",
						padding: "14px 18px",
						borderRadius: "8px",
						lineHeight: "1.5",
						fontWeight: 500,
						boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
						color: "#333",
						textAlign: "justify",
					}}
				>
					<i
						className="zmdi zmdi-info-outline"
						style={{
							color: "#e78e4b",
							fontSize: "18px",
							display: "block",
							marginBottom: "10px",
						}}
					/>
					<ul
						style={{
							paddingLeft: "20px",
							margin: 0,
							listStyleType: "disc", // 👈 bullets normais
						}}
					>
						<li>{translator(currentLanguage, "shareexammsg")}</li>

						{activeTab === "email" && (
							<>
								<li>{translator(currentLanguage, "shareexammsgemail")}</li>
							</>
						)}
						<li>{translator(currentLanguage, "shareexammsgadd")}</li>
					</ul>
				</div>

				<div
					style={{
						display: "flex",
						alignItems: "center",
						marginTop: "4px",
						gap: "24px",
					}}
				>
					<label
						style={{
							display: "flex",
							alignItems: "center",
							gap: "8px",
							color: "#333",
							cursor: "pointer",
						}}
					>
						<input
							type="checkbox"
							checked={shareReport}
							onChange={(e) => setShareReport(e.target.checked)}
							style={{
								accentColor: "#e78e4b",
								width: "18px",
								height: "18px",
							}}
						/>
						<span>{translator(currentLanguage, "report")}</span>
					</label>

					<label
						style={{
							display: "flex",
							alignItems: "center",
							gap: "8px",
							color: "#333",
							cursor: "pointer",
						}}
					>
						<input
							type="checkbox"
							checked={shareImages}
							onChange={(e) => setShareImages(e.target.checked)}
							style={{
								accentColor: "#e78e4b",
								width: "18px",
								height: "18px",
							}}
						/>
						<span>{translator(currentLanguage, "images")}</span>
					</label>
				</div>

				<div
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "space-between",
						marginTop: "8px",
						gap: "12px",
						flexWrap: "wrap", // 👈 permite responsividade
					}}
				>
					{/* Drop de duração */}
					<div style={{ flex: "0 0 45%" }}>
						<label
							style={{
								fontWeight: 600,
								color: "#333",
								marginBottom: "6px",
								display: "block",
							}}
						>
							{translator(currentLanguage, "share_duration")}
						</label>
						<select
							style={{
								width: "100%",
								padding: "10px 12px",
								border: "1px solid #d0d0d0",
								borderRadius: "8px",
								backgroundColor: "#fff",
								color: "#333",
								fontSize: "14px",
								fontWeight: 500,
								boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
								cursor: "pointer",
								transition: "all 0.25s ease",
								appearance: "none",
								backgroundImage:
									"url('data:image/svg+xml;utf8,<svg fill=%22%23e78e4b%22 height=%2220%22 viewBox=%220 0 24 24%22 width=%2220%22 xmlns=%22http://www.w3.org/2000/svg%22><path d=%22M7 10l5 5 5-5z%22/></svg>')",
								backgroundRepeat: "no-repeat",
								backgroundPosition: "right 12px center",
								backgroundSize: "16px",
							}}
							value={expireDays}
							onChange={(e) => {
								setExpireDays(e?.target?.value ?? 1);
							}}
							onFocus={(e) => {
								e.target.style.border = "1px solid #e78e4b";
								e.target.style.boxShadow = "0 0 0 3px rgba(231,142,75,0.25)";
							}}
							onBlur={(e) => {
								e.target.style.border = "1px solid #d0d0d0";
								e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.05)";
							}}
							onMouseEnter={(e) =>
								(e.target.style.border = "1px solid #e78e4b")
							}
							onMouseLeave={(e) =>
								(e.target.style.border = "1px solid #d0d0d0")
							}
						>
							<option value={30}>
								{translator(currentLanguage, "share1month")}
							</option>
							<option value={60}>
								{translator(currentLanguage, "share2month")}
							</option>
							<option value={90}>
								{translator(currentLanguage, "share3month")}
							</option>
						</select>
					</div>
					{activeTab === "email" && (
						<div style={{ flex: "0 0 45%" }}>
							<label
								style={{
									fontWeight: 600,
									color: "#333",
									marginBottom: "6px",
									display: "block",
								}}
							>
								{translator(currentLanguage, "email")}
							</label>
							<div style={{ position: "relative", width: "100%" }}>
								<input
									type="email"
									style={{
										width: "100%",
										padding: "10px 36px 10px 12px", // espaço à direita para o ícone
										border:
											isValidEmail(shareEmail) || shareEmail === ""
												? "1px solid #d0d0d0"
												: "1px solid #e74c3c",
										borderRadius: "8px",
										backgroundColor: "#fff",
										color: "#333",
										fontSize: "14px",
										fontWeight: 500,
										boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
										transition: "all 0.25s ease",
									}}
									onFocus={(e) => {
										e.target.style.border = "1px solid #e78e4b";
										e.target.style.boxShadow =
											"0 0 0 3px rgba(231,142,75,0.25)";
									}}
									onBlur={(e) => {
										e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.05)";
									}}
									onMouseEnter={(e) =>
										(e.target.style.border = "1px solid #e78e4b")
									}
									onMouseLeave={(e) => {
										if (!isValidEmail(shareEmail) && shareEmail !== "")
											e.target.style.border = "1px solid #e74c3c";
										else e.target.style.border = "1px solid #d0d0d0";
									}}
									value={shareEmail}
									onChange={(e) => {
										setShareEmail(e?.target?.value ?? "");
									}}
								/>
								{!isValidEmail(shareEmail) && shareEmail !== "" && (
									<i
										className="zmdi zmdi-alert-circle"
										style={{
											position: "absolute",
											right: "12px",
											top: "50%",
											transform: "translateY(-50%)",
											color: "#e74c3c",
											fontSize: "18px",
											pointerEvents: "none",
										}}
										title="Invalid email address"
									/>
								)}
							</div>
						</div>
					)}
					<div style={{ width: "100%" }}>
						<button
							style={{
								width: "100%",
								background:
									activeTab === "email" && !isValidEmail(shareEmail)
										? "#f2c7a2"
										: "#e78e4b",
								color: "#fff",
								border: "none",
								borderRadius: "8px",
								padding: "12px 0",
								fontWeight: 600,
								boxShadow:
									activeTab === "email" && !isValidEmail(shareEmail)
										? "none"
										: "0 3px 8px rgba(231, 142, 75, 0.4)",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								fontSize: "15px",
								gap: "6px",
								cursor:
									activeTab === "email" && !isValidEmail(shareEmail)
										? "not-allowed"
										: "pointer",
								opacity:
									activeTab === "email" && !isValidEmail(shareEmail) ? 0.7 : 1,
								transition: "all 0.25s ease",
							}}
							disabled={activeTab === "email" && !isValidEmail(shareEmail)}
							onMouseEnter={(e) => {
								if (e.currentTarget.disabled) return; // 👈 evita hover quando disabled
								e.currentTarget.style.background = "#d97b3f";
								e.currentTarget.style.boxShadow =
									"0 4px 10px rgba(231, 142, 75, 0.55)";
								e.currentTarget.style.transform = "translateY(-1px)";
							}}
							onMouseLeave={(e) => {
								if (e.currentTarget.disabled) return;
								e.currentTarget.style.background = "#e78e4b";
								e.currentTarget.style.boxShadow =
									"0 3px 8px rgba(231, 142, 75, 0.4)";
								e.currentTarget.style.transform = "translateY(0)";
							}}
							onClick={async (e) => {
								e.preventDefault();
								if (activeTab === "email" && !isValidEmail(shareEmail)) return;
								let resultToken = "";
								var shareExamData = {
									PatientId: currentSelectedExam?.patId,
									ExamId: currentSelectedExam?.id,
									Email: shareEmail,
									Report: shareReport,
									Images: shareImages,
									Days: expireDays,
									RefUserId: userInfo?.id ?? null,
								};
								var data = await xhrClinicalShareExam(token, shareExamData);
								toastUtil({ currentLanguage, data, success: true });
								resultToken = data?.result?.data?.shareUrl ?? "";
								{
									if (activeTab === "email") {
										setShowExamShareModal(false); // fecha após envio
									} else {
										setResultAskedToken(resultToken); // mostra textarea
									}
								}
							}}
						>
							<i
								className="zmdi zmdi-share"
								style={{ marginRight: "6px", fontSize: "1.2em" }}
							></i>
							{activeTab === "email"
								? translator(currentLanguage, "sendemail")
								: translator(currentLanguage, "share")}
						</button>
					</div>
				</div>
				{resultAskedToken && (
					<div
						style={{
							marginTop: "16px",
							background: "#f9f9f9",
							padding: "12px",
							borderRadius: "8px",
							border: "1px solid #ddd",
							transition: "all 0.3s ease",
						}}
					>
						<p
							style={{
								marginBottom: "6px",
								fontWeight: 600,
								color: "#555",
							}}
						>
							Generated Link
						</p>
						<textarea
							rows={10}
							style={{
								width: "100%",
								color: "#333",
								border: "1px solid #ccc",
								borderRadius: "6px",
								padding: "8px",
								fontSize: "13px",
								resize: "none",
								background: "#fff",
							}}
							readOnly
							value={resultAskedToken}
						></textarea>

						<button
							style={{
								marginTop: "8px",
								background: "#05585E",
								color: "#fff",
								border: "none",
								padding: "8px 14px",
								borderRadius: "8px",
								fontSize: "14px",
								fontWeight: 600,
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: "6px",
								boxShadow: "0 3px 8px rgba(5, 88, 94, 0.3)",
								cursor: "pointer",
								transition: "all 0.25s ease",
								float: "right",
							}}
							onMouseEnter={(e) => {
								e.currentTarget.style.background = "#0b6f74";
								e.currentTarget.style.boxShadow =
									"0 4px 10px rgba(5, 88, 94, 0.45)";
								e.currentTarget.style.transform = "translateY(-1px)";
							}}
							onMouseLeave={(e) => {
								e.currentTarget.style.background = "#05585E";
								e.currentTarget.style.boxShadow =
									"0 3px 8px rgba(5, 88, 94, 0.3)";
								e.currentTarget.style.transform = "translateY(0)";
							}}
							title={translator(currentLanguage, "copy")}
							onClick={async () => {
								toastUtilText(currentLanguage, "Success", "Link copied");
								navigator.clipboard.writeText(resultAskedToken);
							}}
						>
							<i
								className="zmdi zmdi-copy"
								style={{ marginRight: "4px", fontSize: "1.2em" }}
							></i>
							{translator(currentLanguage, "copy")}
						</button>
					</div>
				)}
			</div>
		</CustomModal>
	);
}

export default ExamShareModal;
